<template>
  <v-snackbar
    v-model="alertIsShowing"
    :color="optionAlertColor"
    :transition="optionAlertTransition"
    elevation="24"
    :timeout="optionAlertTimeout"
    :right="isAlertInfo"
    :top="isAlertInfo"
    :class="isAlertInfo ? 'mt-16' : ''"
    :max-width="isAlertInfo ? '400' : ''"
  >
    <template #action="{ attrs }">
      <v-btn
        v-if="hasClickHandler"
        icon
        v-bind="attrs"
        @click="onClick"
      >
        <v-icon>
          mdi-message-arrow-right-outline
        </v-icon>
      </v-btn>

      <v-btn
        icon
        v-bind="attrs"
        @click="hideAlert"
      >
        <v-icon>
          close
        </v-icon>
      </v-btn>
    </template>
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-if="alert"
      @click="onClick"
      v-html="alert.message"
    />
    <!-- eslint-enable -->
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { ALERT_TYPES } from '@/store/shared/partials/alert-handler'

import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'AlertBoxV2',

  data () {
    return {
      alertTimeout: undefined,
    }
  },

  computed: {
    alertIsShowing: {
      get () {
        return this.isShowing
      },

      set (value) {
        this.updateAlertShowing(value)
      },
    },

    hasClickHandler () {
      return this.alert && this.alert.options && typeof this.alert.options.onClick === 'function'
    },

    isAlertInfo () {
      return this.alert && this.alert.type === ALERT_TYPES.INFO
    },

    optionAlertColor () {
      if (this.options && this.options.color) return this.options.color
      if (this.isAlertInfo) return 'deep-purple accent-4'

      return this.alert?.type
    },

    optionAlertTimeout () {
      if (this.options && this.options.timeout !== undefined) return this.options.timeout
      return 5000
    },

    optionAlertTransition () {
      if (this.options && this.options.transition) return this.options.transition
      if (this.isAlertInfo) return 'slide-x-reverse-transition'

      return 'slide-y-reverse-transition'
    },

    ...mapGetters(SHARED_NAMESPACE, [
      'alert',
      'alertVersion',
      'isShowing',
      'options',
    ]),
  },

  watch: {
    alertVersion: {
      immediate: true,

      handler () {
        // Reset timeout when alert changes
        if (this.alertTimeout) {
          clearTimeout(this.alertTimeout)
        }

        if (this.optionAlertTimeout > 0) {
          this.alertTimeout = setTimeout(_ => {
            this.hideAlert()
          }, this.optionAlertTimeout)
        }
      },
    },
  },

  methods: {
    hideAlert () {
      this.alertIsShowing = false
    },

    onClick () {
      if (this.hasClickHandler) {
        this.alert.options.onClick()
      }
    },

    ...mapActions(SHARED_NAMESPACE, [
      'updateAlertShowing',
    ]),
  },

}
</script>
